import { useMemo } from 'react';
import { useAppSelector } from '../../../app/hooks';
import { validateWorkflow, isWorkflowValid, ValidationErrors } from '../../../services/WorkflowService';

/**
 * useWorkflowValidation – thin React wrapper around the pure validateWorkflow function.
 * Re-computes whenever the Redux workflow state changes.
 */
export const useWorkflowValidation = () => {
  const currentWorkflow = useAppSelector((state) => state.workflow.currentWorkflow);
  const isEdited = useAppSelector((state) => state.workflow.isEdited);

  const errors = useMemo<ValidationErrors>(() => {
    if (!currentWorkflow) return {};
    return validateWorkflow(currentWorkflow);
  }, [currentWorkflow]);

  const isValid = isWorkflowValid(errors);

  return { errors, isValid, isEdited };
};
